import { useEffect } from 'react'
import { UseQueryResult } from '@tanstack/react-query'
import { useFeatureFlags } from '@node-space/hooks'
import { DynamicFieldsSections } from 'constants/dynamicFields'
import { useVerticalContext } from './context/useVerticalContext'
import { useAccountContactsQuery } from './queries/useAccountContactsQuery'
import { useBusinessDetailsQuery } from './queries/useBusinessDetailsQuery'
import { useBusinessVerificationStatusQuery } from './queries/useBusinessVerificationStatus'
import { useDynamicFieldsQuery } from './queries/useDynamicFieldsQuery'
import { useIndustriesQuery } from './queries/useIndustriesQuery'

export const useVerificationStepsData = () => {
  const { enableAccountContactsCrud, enableDynamicDocuments, enableDynamicQuestions } =
    useFeatureFlags()
  const { setBusinessDetails, setIndustryOptions } = useVerticalContext()

  const businessVerificationStatus = useBusinessVerificationStatusQuery()
  const businessDetails = useBusinessDetailsQuery()
  const industryOptions = useIndustriesQuery()
  const accountContacts = useAccountContactsQuery({ isEnabled: !!enableAccountContactsCrud })
  const dynamicFields = useDynamicFieldsQuery([
    ...(!!enableDynamicDocuments ? [DynamicFieldsSections.DOCUMENTS] : []),
    ...(!!enableDynamicQuestions ? [DynamicFieldsSections.QUESTIONS] : []),
  ])

  const stepsDataRequests = {
    businessVerificationStatus,
    businessDetails,
    industryOptions,
    accountContacts,
    dynamicFields,
  }

  const requestKeys = Object.keys(stepsDataRequests)
  const isFetchingStepsData = requestKeys.some(
    key => (stepsDataRequests?.[key] as UseQueryResult)?.isFetching
  )
  const isErrorFetchingStepsData = requestKeys.some(
    key => (stepsDataRequests?.[key] as UseQueryResult)?.isError
  )

  useEffect(() => {
    !industryOptions?.isFetching && setIndustryOptions(industryOptions?.data)
  }, [industryOptions?.isFetching, industryOptions?.data])

  useEffect(() => {
    !businessDetails?.isFetching && setBusinessDetails(businessDetails?.data)
  }, [businessDetails?.data, businessDetails?.isFetching])

  return {
    stepsDataRequests,
    isFetchingStepsData,
    isErrorFetchingStepsData,
  }
}
